import { articleFields } from "../fragments";


export default `
  ${articleFields}
  
  query($articleId: String! $fasterMode: Boolean, $massiveMode: Boolean) {
    article(articleId: $articleId, fasterMode: $fasterMode, massiveMode: $massiveMode) {
      ...articleFields
    }
  }
`;